__turbopack_context__.v({
  "disabled": "ArrowButton-module-scss-module__F76DsG__disabled",
  "leftArrow": "ArrowButton-module-scss-module__F76DsG__leftArrow",
  "playlistTooltip": "ArrowButton-module-scss-module__F76DsG__playlistTooltip",
  "rightArrow": "ArrowButton-module-scss-module__F76DsG__rightArrow",
  "tiny": "ArrowButton-module-scss-module__F76DsG__tiny",
});
